import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import LoginForm from '../components/LoginForm';

const Login: React.FC = () => {
  return <LoginForm />;
};

export default Login;
